export default __webpack_public_path__ + "static/home_page_visualization-9d9b34247455ff0af861343ebd17b376.mp4";